import { render } from "./AbyssDream.vue?vue&type=template&id=266eb224"
import script from "./AbyssDream.vue?vue&type=script&lang=js"
export * from "./AbyssDream.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__